// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1fKaw","title":"Info_title__dZeX6","links":"Info_links__SITDA","link":"Info_link__eQemw","logo":"Info_logo__3jtDk"};